import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding
  const menuUrls = store.getters && store.getters.menuUrls

  if (value && value instanceof Array) {
    if (value.length > 0) {
      const permissionUrls = value

      const hasPermission = menuUrls.some(url => {
        return permissionUrls.includes(url)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  } else {
    throw new Error(`need menuUrls! Like v-permission="['/user/save','/user/remove']"`)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
